/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { get, post, downloadFile } from "../../../http/shared";

export interface IBulkExportServiceConfig {
  baseUrl?: string;
}

export type DataSources = {
  id: number;
  parentId?: number;
  name: string;
};

export type MeasurementValues = {
  id: number;
  identifier: string;
  name: string;
  visible: boolean;
};

export type Configuration = {
  id: number;
  name: string;
  identifier: string;
  measureId: number;
};

export type Calendar = {
  // FIXME Write the type depending on the backend data
};

export enum BulkExportError {
  None,
  Network,
  Server,
  BadRequest,
}

export class BulkExportServiceOld {
  private _baseUrl: string;
  private _error$ = new Subject<BulkExportError>();
  private _loading$ = new BehaviorSubject<boolean>(false);
  private _dataSources$ = new BehaviorSubject<DataSources[]>([]);
  private _measurementValues$ = new BehaviorSubject<MeasurementValues[]>([]);
  private _calendar$ = new BehaviorSubject<Calendar[]>([]);
  private _configuration$ = new BehaviorSubject<Configuration[]>([]);

  public get error$() {
    return this._error$.asObservable();
  }

  public get loading$() {
    return this._loading$.asObservable();
  }

  public get loading() {
    return this._loading$.value;
  }

  public get dataSources$() {
    return this._dataSources$.asObservable();
  }

  public get dataSources() {
    return this._dataSources$.value;
  }

  public get measurementValues$() {
    return this._measurementValues$.asObservable();
  }

  public get measurementValues() {
    return this._measurementValues$.value;
  }

  public get calendar$() {
    return this._calendar$.asObservable();
  }

  public get calendar() {
    return this._calendar$.value;
  }

  public get configuration$() {
    return this._configuration$.asObservable();
  }

  public get configuration() {
    return this._configuration$.value;
  }

  constructor(config?: IBulkExportServiceConfig) {
    this._baseUrl = (config?.baseUrl || "/api") + "/BulkExport";
  }

  async getDataSources() {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/DataSources`);
      result.json().then((res) => {
        this._dataSources$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  async getMeasurementValues(dataSourceId: number) {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/dimensions/${dataSourceId}`);
      result.json().then((res) => {
        this._measurementValues$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  async getConfiguration(dataSourceId: number) {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/configuration/${dataSourceId}`);
      result.json().then((res) => {
        this._configuration$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  //FIXME Add a parameter in function, depending on which data will be selected
  async getCalendar() {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/calendar`);
      result.json().then((res) => {
        this._calendar$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  // FIXME type params
  async checkNumberOfRecords(params: any) {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/checkNumberOfRecords`, params);
      return result.json().then((res: boolean) => {
        this._loading$.next(false);
        return res;
      });
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  async getItems(dimensionName: string) {
    try {
      this._loading$.next(true);

      const result = await get(`${this._baseUrl}/Measures/${dimensionName}/items `);
      // FIXME type
      return result.json().then((res: any[]) => {
        this._loading$.next(false);
        return res;
      });
    } catch (err) {
      this._loading$.next(false);
      // TODO: Добавить логику обработки ошибок
      throw err;
    }
  }

  async getBulkExportResult(params: any) {
    try {
      this._loading$.next(true);

      const url = `${this._baseUrl}/result`;
      const resp = await post(`${url}`, params);
      if (resp.ok) {
        const blob = await resp.blob();
        // FIXME Add function for fileName
        const fileName = "";
        downloadFile(blob, fileName);
        return true;
      }

      this._loading$.next(false);
      return false;
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get export result fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }
}
